module.exports = __webpack_public_path__ + "static/react-846d90f0ba5c80c1a554cf6fe02b7f1f.png";